import { IExtraOption, IMergeOptions } from './types'

// this is a special case for plus separator which defines the word prefix
const replaceSpacesIfNeeded = (line: string, wordPrefix: string) => {
  if (wordPrefix !== '') {
    line = ' ' + line
    return line.replace(/ /g, ` ${wordPrefix}`)
  }
  return line
}

const getExtraOptions = (separator: IExtraOption, wrapper: IExtraOption) => {
  const isPlus = separator.kind === 'plus'

  // plus is a special case - instead of adding separators between data from the inputs
  // it adds the prefix before every word
  // (it makes difference if any input contains multiple words separated by space)
  const sep = isPlus ? ' ' : separator.value
  const wordPrefix = isPlus ? '+' : ''

  const prefix = wrapper.value.charAt(0)
  const suffix = wrapper.value.charAt(1)

  return { sep, wordPrefix, prefix, suffix }
}

export const merge = (mergeOptions: IMergeOptions): string => {
  const { first, second, third, separator, wrapper } = mergeOptions

  const { prefix, sep, suffix, wordPrefix } = getExtraOptions(
    separator,
    wrapper
  )

  const c1 = first.split('\n')
  const c2 = second.split('\n')
  const c3 = third.split('\n')

  const results: string[] = []

  c1.forEach(el1 => {
    c2.forEach(el2 => {
      c3.forEach(el3 => {
        let line = prefix + [el1, el2, el3].filter(Boolean).join(sep) + suffix
        line = replaceSpacesIfNeeded(line, wordPrefix)
        results.push(line.trim())
      })
    })
  })

  return results.join('\n')
}
